import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";
import { Action, Mutation } from "vuex-class";
import * as types from "@/store/constants/types";
import Nav from "@/components/nav/navBar.vue";
import { canvasCompress, mergePhoto } from "@/utils/canvasCompress";
import routerTempHelpers from "@/utils/routerTempHelpers";
import { filterBase64Pic } from "@/api/utils/apiHelper";
import { isObject } from "@/utils/deepCloneUtil";
import { judgeFutureBabyVersion } from "@/utils/judgeVersion";
import generalUtils from "@/utils/generalUtils";
import HeartsAnimate from "./heartsAnimate.vue";

var ComposeProcess =
/*#__PURE__*/
function (_Vue) {
  _inherits(ComposeProcess, _Vue);

  function ComposeProcess() {
    var _this;

    _classCallCheck(this, ComposeProcess);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ComposeProcess).apply(this, arguments));
    _this.faceOneUrl = "";
    _this.faceTwoUrl = "";
    _this.retryTimes = 0;
    _this.showFutrueInput = false;
    _this.resultKey = "";
    _this.star = false;
    return _this;
  }

  _createClass(ComposeProcess, [{
    key: "clickClose",
    value: function clickClose() {
      this.routerGoBack(-1);
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.initData();
    }
  }, {
    key: "destroyed",
    value: function destroyed() {
      this.showFutrueInput = false;
    }
  }, {
    key: "initData",
    value: function () {
      var _initData = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var temp, cameraResultOne, cameraResultTwo, starOne, starTwo, faceOneUrl, faceTwoUrl, zip_base64_photo_one, zip_base64_photo_two, last_base64_photo, result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                temp = routerTempHelpers.getQueryTemp(this.$route.query);
                cameraResultOne = temp.imageData.cameraResultOne;
                cameraResultTwo = temp.imageData.cameraResultTwo; // 代表第一张第二章是否是明星照片

                starOne = this.star = temp.imageData.starOne;
                starTwo = temp.imageData.starTwo;
                faceOneUrl = isObject(cameraResultOne) ? cameraResultOne.base64 : cameraResultOne;
                faceTwoUrl = isObject(cameraResultTwo) ? cameraResultTwo.base64 : cameraResultTwo;
                this.faceOneUrl = starOne ? faceOneUrl : "data:image/jpeg;base64," + faceOneUrl;
                this.faceTwoUrl = starTwo ? faceTwoUrl : "data:image/jpeg;base64," + faceTwoUrl;

                if (!this.star) {
                  _context.next = 14;
                  break;
                }

                setTimeout(function () {
                  _this2.routerPush({
                    name: "futureBabyResult",
                    params: {
                      routerTransition: "forward",
                      showVipRightNow: true
                    },
                    query: {
                      tempKey: routerTempHelpers.setQueryTemp({
                        image_one: _this2.faceOneUrl,
                        image_two: _this2.faceTwoUrl,
                        filePath_one: cameraResultOne.filePath,
                        filePath_two: cameraResultTwo.filePath,
                        star: _this2.star
                      })
                    }
                  });
                }, 2500);
                _context.next = 39;
                break;

              case 14:
                if (!judgeFutureBabyVersion()) {
                  _context.next = 25;
                  break;
                }

                if (!this.isVip) {
                  _context.next = 21;
                  break;
                }

                _context.next = 18;
                return this.syncGetFutureBabyResult({
                  filePath_one: cameraResultOne.filePath,
                  filePath_two: cameraResultTwo.filePath
                });

              case 18:
                this.routerPush({
                  name: "futureBabyResult",
                  params: {
                    routerTransition: "forward",
                    showVipRightNow: true
                  },
                  query: {
                    tempKey: routerTempHelpers.setQueryTemp({
                      image_one: this.faceOneUrl,
                      image_two: this.faceTwoUrl,
                      filePath_one: cameraResultOne.filePath,
                      filePath_two: cameraResultTwo.filePath
                    })
                  }
                });
                _context.next = 23;
                break;

              case 21:
                // 先异步的抓取数据
                this.asyncGetFutureBabyResult({
                  filePath_one: cameraResultOne.filePath,
                  filePath_two: cameraResultTwo.filePath
                });
                setTimeout(function () {
                  _this2.routerPush({
                    name: "futureBabyResult",
                    params: {
                      routerTransition: "forward",
                      showVipRightNow: true
                    },
                    query: {
                      tempKey: routerTempHelpers.setQueryTemp({
                        image_one: _this2.faceOneUrl,
                        image_two: _this2.faceTwoUrl,
                        filePath_one: cameraResultOne.filePath,
                        filePath_two: cameraResultTwo.filePath
                      })
                    }
                  });
                }, 1500);

              case 23:
                _context.next = 39;
                break;

              case 25:
                _context.next = 27;
                return canvasCompress(this.faceOneUrl);

              case 27:
                zip_base64_photo_one = _context.sent;
                _context.next = 30;
                return canvasCompress(this.faceTwoUrl);

              case 30:
                zip_base64_photo_two = _context.sent;
                _context.next = 33;
                return mergePhoto(zip_base64_photo_one, zip_base64_photo_two);

              case 33:
                last_base64_photo = _context.sent;
                _context.next = 36;
                return this.preFaceCheck({
                  type: 1,
                  base64_photo: filterBase64Pic(last_base64_photo)
                });

              case 36:
                result = _context.sent;
                this.resultKey = result.key;
                this.showFutrueInput = true;

              case 39:
                _context.next = 44;
                break;

              case 41:
                _context.prev = 41;
                _context.t0 = _context["catch"](0);

                if (judgeFutureBabyVersion()) {
                  this.showNetWorkToast(this.clickClose);
                } else {
                  this.retryTimes++;

                  if (this.retryTimes <= 4) {
                    setTimeout(function () {
                      _this2.initData();
                    }, 3000);
                  } else {
                    this.showNetWorkToast(this.clickClose);
                  }
                }

              case 44:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 41]]);
      }));

      function initData() {
        return _initData.apply(this, arguments);
      }

      return initData;
    }()
  }, {
    key: "isVip",
    get: function get() {
      return generalUtils.isVip();
    }
  }]);

  return ComposeProcess;
}(Vue);

tslib_1.__decorate([Action(types.ROUTER_GO_BACK)], ComposeProcess.prototype, "routerGoBack", void 0);

tslib_1.__decorate([Action(types.ROUTER_PUSH)], ComposeProcess.prototype, "routerPush", void 0);

tslib_1.__decorate([Action(types.PRE_FACE_CHECK)], ComposeProcess.prototype, "preFaceCheck", void 0);

tslib_1.__decorate([Action(types.GET_FUTURE_BABY_RESULT_NEW)], ComposeProcess.prototype, "getFutureBabyResultNew", void 0);

tslib_1.__decorate([Mutation(types.SHOW_NETWORK_TOAST)], ComposeProcess.prototype, "showNetWorkToast", void 0);

tslib_1.__decorate([Action(types.ASYNC_GET_FUTURE_BABY_RESULT)], ComposeProcess.prototype, "asyncGetFutureBabyResult", void 0);

tslib_1.__decorate([Action(types.SYNC_GET_FUTURE_BABY_RESULT)], ComposeProcess.prototype, "syncGetFutureBabyResult", void 0);

tslib_1.__decorate([Mutation(types.UPDATE_RESULT_BY_NAME)], ComposeProcess.prototype, "updateResultByName", void 0);

ComposeProcess = tslib_1.__decorate([Component({
  components: {
    Nav: Nav,
    HeartsAnimate: HeartsAnimate
  }
})], ComposeProcess);
export default ComposeProcess;